import { client } from "../utils/netlify";
import { setCookie, getCookie } from "cookies-next";
import { reportError } from "./errorHelper";

export const rewardDiscount = async (userSegmentCheck) => {
  let discountData = false;
  if (discountData) {
    discountData = JSON.parse(discountData);
  }
  else {
    const discountValue = {
      "discount": userSegmentCheck,
      "queryFirst": 50
    }
    try {
      discountData = await client("get-reward-discount", discountValue);
      let discountDataFilter = [];
      if(discountData) {
        discountData?.forEach(data => {
          let obj = {};
          let disObj = data.node.discount;
          if (disObj && Object.keys(disObj).length > 0) {
            try {
              obj.title = disObj.title;
              obj.status = disObj.status;
              obj.endsAt = disObj.endsAt ? new Date(disObj.endsAt).toISOString().split('T')[0] : null;
              obj.cartValue = (disObj.minimumRequirement != null) ? Number(disObj?.minimumRequirement?.greaterThanOrEqualToSubtotal?.amount) : 0.00;
              discountDataFilter.push(obj);
            }
            catch (e) {
              reportError("Error in reward discount data")
              reportError(e)
            }
          }
        })
        const sortDiscount = (value1, value2) => {
          if (value1.cartValue < value2.cartValue) {
            return 1;
          }
          if (value1.cartValue > value2.cartValue) {
            return -1;
          }
          return 0;
        }
        discountDataFilter = discountDataFilter.sort(sortDiscount);
        discountData = discountDataFilter;
        //setCookie('user_discount', discountData, { maxAge: 900 });
      }
    }
    catch (e) {
      reportError("Error in reward discount")
      reportError(e)
      return false;
    }
  }
  return discountData;
};

export const getDiscountData = async (userSegmentCheck) => {
  let eventClosed = false;
  let discountData = await rewardDiscount(userSegmentCheck);
  var today = new Date();
  if (!discountData) {
    return false;
  }
  discountData.forEach(discount => {
    if (discount.endsAt && today > discount.endsAt) {
      eventClosed = true;
    }
    if (discount.status == 'EXPIRED') {
      eventClosed = true;
    }
  })
  if (eventClosed) {
    return false;
  }
  return discountData;
}